export function Spinner({ size = 16 }: { size?: number }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: "2px solid #cbd5e1",
        borderTopColor: "#0f766e",
        display: "inline-block",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
}
